<template>
  <v-container class="main-container responsive-height mt5-wrapper">
    <v-row dense>
      <v-col cols="12" class="position-relative">
        <live-account-all-tabs></live-account-all-tabs>
        <div class="mt5-create-account">
          <CreateAccountDropdown></CreateAccountDropdown>
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import CreateAccountDropdown from "@/components/GlobalComponents/CreateAccountDropdown";
import LiveAccountAllTabs from '@/components/PagesComponents/LiveAccountPage/LiveAccountAllTabs.vue';
export default {
  components: {
    CreateAccountDropdown,
    LiveAccountAllTabs,
  },
};
</script>
